export default {
  computed: {
    isAdmin() {
      // console.log(this.$auth.user().admin);
      return this.$auth.user().admin;
    },
    isSuperAdmin() {
      // console.log(this.$auth.user().admin);
      return this.$auth.user().id === 201;
    },
  },
};
